import React, { memo, useMemo } from "react";
import styled from "styled-components";

const normalizeSpaces = (value) => {
  if (!value) return value;
  const withoutNbsp = value.replace(/&nbsp;/g, " ");
  return withoutNbsp.replace(/\s{2,}/g, " ");
};

const InstructionContent = styled.div`
  &,
  & * {
    word-spacing: normal;
    font-size: max(12px, 1em);
  }
`;

const QuestionInstruction = styled.span`
  display: block;
  word-spacing: normal;
`;


const PlacementInstructionBlock = ({ sectionInstruction, questionInstruction }) => {
  const normalizedSectionInstruction = useMemo(
    () => sectionInstruction,
    [sectionInstruction]
  );

  const normalizedQuestionInstruction = useMemo(
    () => normalizeSpaces(questionInstruction),
    [questionInstruction]
  );

  return (
    <>
      {normalizedSectionInstruction ? (
        <InstructionContent
          className="instruction-content"
          dangerouslySetInnerHTML={{ __html: normalizedSectionInstruction }}
        />
      ) : null}
      <QuestionInstruction style={{ marginTop:normalizedSectionInstruction ? "20px" : "0px" }}>{normalizedQuestionInstruction}</QuestionInstruction>
    </>
  );
};

export default memo(PlacementInstructionBlock);
